import * as Yup from "yup";

const nfSaidaPagamentosValidator = () =>
  Yup.array()
    .of(
      Yup.object().shape({
        meioPagamentoId: Yup.number().required(),
        condicaoPagamentoId: Yup.number().required(),
        dataVencimento: Yup.date().required(),
        valorTitulo: Yup.number().required(),
        numeroTitulo: Yup.number().required(),
      }),
    )
    .min(1, "Adicionar ao menos um pagamento")
    .required();

export default nfSaidaPagamentosValidator;
